/**
 * Design System Grid
 */

import { type BreakPoint, MEDIA_QUERY } from '@bucketplace/design-system';
import {
  COLUMN_PRESET,
  type GridItemProps,
  TOTAL_COLUMN,
} from '@bucketplace/design-system/bds';
import { css, type SerializedStyles } from '@emotion/react';

export type Gap =
  | number
  | string
  | {
      mobile?: number | string;
      tablet?: number | string;
      laptop?: number | string;
    };

export interface GridGap {
  row: string;
  column: string;
}

export type ColumnPreset = 'full' | 'half' | 'quarter';

export function cssColumn(column: GridItemProps['column']): SerializedStyles {
  const {
    mobile = 1,
    tablet = mobile,
    laptop = tablet,
  } = typeof column === 'object' ? column : COLUMN_PRESET[column];

  return css`
    ${mapToColumn('mobile', mobile)};
    ${mapToColumn('tablet', tablet)};
    ${mapToColumn('laptop', laptop)};
  `;
}

function mapToColumn(
  breakPoint: BreakPoint,
  column: number | ColumnPreset,
): SerializedStyles {
  const size =
    typeof column === 'number' ? column : COLUMN_PRESET[column][breakPoint];

  const width = (100 / TOTAL_COLUMN[breakPoint]) * size;

  return breakPoint === 'mobile'
    ? css`width: ${width}%;`
    : css`${MEDIA_QUERY.min(breakPoint, `width: ${width}%;`)}`;
}
